<template lang="pug">
header.v-page-header.page-header-lk
	.page-header-lk__container
		.page-header-lk__layout(v-if="data")
			.page-header-lk__left
				component.page-header-lk__link(:is="data?.logo?.href ? 'a' : 'div'" :href="data?.logo?.href")
					v-svg-icon.page-header-lk__logo(
						v-if="data?.logo&& data.logo.icon"
						:icon="data.logo.icon"
						)
			.page-header-lk__right(v-if="isSm")
				button.page-header-lk__menu-btn(v-if="data.button" :type="data.button?.type" @click="openMobileNav", :aria-label="data.button?.ariaLabel")
					v-svg-icon.page-header-lk__menu-icon(:icon="data.button?.icon")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: {},
			open: false
		};
	},

	created() {
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		openMobileNav() {
			controller.openLkMobileMenu();
		},

		closeMobileNav() {

		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.open) {
				e.stopPropagation();
				this.open = false;
			}
		}
	}
};
</script>
